import { useQuery } from "@tanstack/react-query";
import { getAuthenticatedApiClient } from "../../../api/apiClient";

/**
 * Reads one counterparty from the data warehouse by its shared id (BvdIdNumber on the compliance
 * side, CreditCatalystID on the risk side).
 *
 * This duplicates the query key used by features/counterpartyLookup on purpose: shared components
 * do not import from features in this codebase, and matching the key keeps both consumers on one
 * cache entry so opening the sync dialog after visiting the lookup screen costs no request. Keep it
 * in step with counterpartyLookupKeys.details.
 */
export const useWarehouseLookup = (id?: string) => {
  return useQuery({
    queryKey: ["counterpartyLookup", "details", id ?? "not_set"] as const,
    queryFn: async () => {
      const apiClient = await getAuthenticatedApiClient();
      const response =
        await apiClient.counterpartyLookupDetails.counterpartyLookupDetails({
          id: id ?? "id_should_always_exist"
        });
      return response.data;
    },
    enabled: !!id,
    // A wrong id is the common failure and retrying a 404 three times only delays the message.
    retry: 0
  });
};
